<template>
  <div class="row justify-content-center">
    <div class="col-11 col-lg-4 col-xl-3">
      <logo-bar></logo-bar>
      <form @submit="tryLogin">
        <data-input v-model="username" label="Benutzername" class="mb-4"/>
        <data-input v-model="password" label="Passwort" type="password" class="mb-4 pb-4"/>
        <button class="btn btn-primary btn-block" type="submit" :disabled="loading">{{ $t('Login') }}</button>
      </form>
    </div>
  </div>
</template>

<script>
import DataInput from "../components/DataInput";
import LogoBar from "../components/LogoBar";
import allViews from "../mixins/allViews";
import {mapActions} from 'vuex'

export default {
  name: "Login",
  components: {DataInput, LogoBar},
  mixins: [allViews],
  data() {
    return {
      username: '',
      password: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      login: "Api/Users/login",
      fetchUserDetails: "Api/Users/get",
      refreshCustomers: "Api/Customers/all",
      refreshBottles: "Api/Bottles/all",
    }),
    async tryLogin(e) {
      e.preventDefault();
      let detail = null;
      try {
        this.loading = true;
        await this.login({username: this.username, password: this.password});
        detail = await this.fetchUserDetails({id: "self"});
        this.refreshBottles().catch(this.apiErrorHandler);
        this.refreshCustomers().catch(this.apiErrorHandler);

      } catch (error) {
        this.apiErrorHandler(error);
        this.loading = false;
        throw error;
      }

      if (this.$config.IS_ADMIN_PANEL && ['manager', 'admin'].indexOf(detail.role) > -1) {
        this.$router.push('/admin').catch(console.log);
      } else {
        this.$router.push('/home').catch(console.log);
      }
    }
  }
}
</script>

<style scoped>

</style>
